module.exports = (__webpack_require__(37304))(50);